"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _materialSymbols = require("@design/icons/material-symbols");
var _RedlinePreview = _interopRequireDefault(require("@common/components/remedy/RedlinePreview"));
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _triangleAlert = _interopRequireDefault(require("@assets/triangle-alert.svg"));
var _Regenerate = _interopRequireDefault(require("@assets/Regenerate.svg"));
var _hoverTooltip = require("@common/components/hover-tooltip");
var _document = require("../../utils/document");
var _ooxmlRecovery = require("../../utils/ooxml-recovery");
var _useApplyRedline = require("../../hooks/use-apply-redline");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _CardsNotShownContext = require("../../context/CardsNotShownContext");
var _toast = require("../../utils/toast");
var _errors = require("../../utils/errors");
var _untrackedWriteGuard = require("../../utils/untracked-write-guard");
var _applyOutcome = require("@common/utils/applyOutcome");
var _AIFeedbackModal = _interopRequireDefault(require("./AIFeedbackModal"));
var _LiveProposalPanel = _interopRequireWildcard(require("./LiveProposalPanel"));
var _ProposalCardActions = require("../chat/proposal-card/ProposalCardActions");
var _insertionLandingsContext = require("../chat/proposal-card/insertion-landings-context");
var _RemedyPartSupersededIndicator = require("../chat/proposal-card/RemedyPartSupersededIndicator");
var _RevertedInDocumentIndicator = require("../chat/proposal-card/RevertedInDocumentIndicator");
var _LinksNeedingAddressIndicator = require("../chat/proposal-card/LinksNeedingAddressIndicator");
var _cardCommentSelections = require("../chat/proposal-card/card-comment-selections");
var _ProposalCard = require("../chat/proposal-card/ProposalCard");
var _cardLiveProposal = require("../chat/proposal-card/card-live-proposal");
var _useLiveProposal = require("../../hooks/use-live-proposal");
var _proposalEngineAccess = require("../../utils/proposal-engine-access");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _ProposalEditorOnPage = require("./ProposalEditorOnPage");
var _compare = require("../../utils/compare");
var _ooxmlTextCompare = require("./ooxml-text-compare");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject; // import { useCardDetails } from "../chat/proposal-card/CardDetailsContext";
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var areRedlineSectionPropsEqual = function areRedlineSectionPropsEqual(prevProps, nextProps) {
  var _prevProps$conflictin, _nextProps$conflictin, _prevProps$potentialC, _nextProps$potentialC, _prevProps$proposalCa, _nextProps$proposalCa, _prevProps$proposalCa2, _nextProps$proposalCa2, _prevProps$proposalEd, _nextProps$proposalEd, _prevProps$proposalEd2, _nextProps$proposalEd2, _prevProps$proposalEd3, _nextProps$proposalEd3, _prevProps$proposalEd4, _nextProps$proposalEd4, _prevProps$proposalEd5, _nextProps$proposalEd5, _prevProps$proposalEd6, _nextProps$proposalEd6, _prevProps$heldBackRe, _nextProps$heldBackRe;
  return (0, _compare.areArraysEqual)(prevProps.ooxmls, nextProps.ooxmls) && JSON.stringify(prevProps.textRedline) === JSON.stringify(nextProps.textRedline) && JSON.stringify(prevProps.cardComments) === JSON.stringify(nextProps.cardComments) && prevProps.actionId === nextProps.actionId && (0, _compare.areArraysEqual)(prevProps.target_ooxml_befores, nextProps.target_ooxml_befores) && (0, _compare.areArraysEqual)(prevProps.bookmarks, nextProps.bookmarks) && (0, _compare.areArraysEqual)(prevProps.afterBookmarks, nextProps.afterBookmarks) && prevProps.isRegenerating === nextProps.isRegenerating && prevProps.showFeedbackForm === nextProps.showFeedbackForm && prevProps.isActionApplied === nextProps.isActionApplied && prevProps.isActionDismissed === nextProps.isActionDismissed && prevProps.isDismissalSaving === nextProps.isDismissalSaving && prevProps.recoveryWarning === nextProps.recoveryWarning && prevProps.applyFailure === nextProps.applyFailure && prevProps.supersededBy === nextProps.supersededBy && prevProps.partSupersededBy === nextProps.partSupersededBy && prevProps.revertedInDocument === nextProps.revertedInDocument && prevProps.partlyRevertedInDocument === nextProps.partlyRevertedInDocument && ((_prevProps$conflictin = prevProps.conflictingCards) !== null && _prevProps$conflictin !== void 0 ? _prevProps$conflictin : []).map(function (card) {
    return "".concat(card.id, ":").concat(card.label);
  }).join(",") === ((_nextProps$conflictin = nextProps.conflictingCards) !== null && _nextProps$conflictin !== void 0 ? _nextProps$conflictin : []).map(function (card) {
    return "".concat(card.id, ":").concat(card.label);
  }).join(",") && ((_prevProps$potentialC = prevProps.potentialCollisions) !== null && _prevProps$potentialC !== void 0 ? _prevProps$potentialC : []).map(function (collision) {
    return "".concat(collision.number, ":").concat(collision.proximity, ":").concat(collision.alsoMakesSameChange);
  }).join(",") === ((_nextProps$potentialC = nextProps.potentialCollisions) !== null && _nextProps$potentialC !== void 0 ? _nextProps$potentialC : []).map(function (collision) {
    return "".concat(collision.number, ":").concat(collision.proximity, ":").concat(collision.alsoMakesSameChange);
  }).join(",") && prevProps.isPartiallyApplied === nextProps.isPartiallyApplied && prevProps.isWrittenBack === nextProps.isWrittenBack && ((_prevProps$proposalCa = prevProps.proposalCard) === null || _prevProps$proposalCa === void 0 ? void 0 : _prevProps$proposalCa.cardNumber) === ((_nextProps$proposalCa = nextProps.proposalCard) === null || _nextProps$proposalCa === void 0 ? void 0 : _nextProps$proposalCa.cardNumber) && ((_prevProps$proposalCa2 = prevProps.proposalCard) === null || _prevProps$proposalCa2 === void 0 ? void 0 : _prevProps$proposalCa2.kind) === ((_nextProps$proposalCa2 = nextProps.proposalCard) === null || _nextProps$proposalCa2 === void 0 ? void 0 : _nextProps$proposalCa2.kind) && prevProps.currentStepIndex === nextProps.currentStepIndex && prevProps.totalSteps === nextProps.totalSteps && ((_prevProps$proposalEd = prevProps.proposalEdit) !== null && _prevProps$proposalEd !== void 0 ? _prevProps$proposalEd : null) === null === (((_nextProps$proposalEd = nextProps.proposalEdit) !== null && _nextProps$proposalEd !== void 0 ? _nextProps$proposalEd : null) === null) && ((_prevProps$proposalEd2 = prevProps.proposalEdit) === null || _prevProps$proposalEd2 === void 0 ? void 0 : _prevProps$proposalEd2.editRequested) === ((_nextProps$proposalEd2 = nextProps.proposalEdit) === null || _nextProps$proposalEd2 === void 0 ? void 0 : _nextProps$proposalEd2.editRequested) && ((_prevProps$proposalEd3 = prevProps.proposalEdit) === null || _prevProps$proposalEd3 === void 0 ? void 0 : _prevProps$proposalEd3.editAuthor) === ((_nextProps$proposalEd3 = nextProps.proposalEdit) === null || _nextProps$proposalEd3 === void 0 ? void 0 : _nextProps$proposalEd3.editAuthor) && JSON.stringify((_prevProps$proposalEd4 = prevProps.proposalEdit) === null || _prevProps$proposalEd4 === void 0 ? void 0 : _prevProps$proposalEd4.textRedlineBeforeEdit) === JSON.stringify((_nextProps$proposalEd4 = nextProps.proposalEdit) === null || _nextProps$proposalEd4 === void 0 ? void 0 : _nextProps$proposalEd4.textRedlineBeforeEdit) && JSON.stringify((_prevProps$proposalEd5 = prevProps.proposalEdit) === null || _prevProps$proposalEd5 === void 0 ? void 0 : _prevProps$proposalEd5.textRedlineWhenOpened) === JSON.stringify((_nextProps$proposalEd5 = nextProps.proposalEdit) === null || _nextProps$proposalEd5 === void 0 ? void 0 : _nextProps$proposalEd5.textRedlineWhenOpened) && JSON.stringify((_prevProps$proposalEd6 = prevProps.proposalEdit) === null || _prevProps$proposalEd6 === void 0 ? void 0 : _prevProps$proposalEd6.textRedlineToEdit) === JSON.stringify((_nextProps$proposalEd6 = nextProps.proposalEdit) === null || _nextProps$proposalEd6 === void 0 ? void 0 : _nextProps$proposalEd6.textRedlineToEdit) && ((_prevProps$heldBackRe = prevProps.heldBackReasonOfTheCard) !== null && _prevProps$heldBackRe !== void 0 ? _prevProps$heldBackRe : null) === ((_nextProps$heldBackRe = nextProps.heldBackReasonOfTheCard) !== null && _nextProps$heldBackRe !== void 0 ? _nextProps$heldBackRe : null);
};
function applyHeldBackReasonOf(isActionApplied, documentAlreadyReadsAsProposed, heldBackReasonOfTheCard, cardBuildFailure) {
  if (isActionApplied) return REDLINE_ALREADY_APPLIED_MESSAGE;
  if (heldBackReasonOfTheCard !== null) return heldBackReasonOfTheCard;
  if (cardBuildFailure !== null) return cardBuildFailure;
  if (documentAlreadyReadsAsProposed) return _LiveProposalPanel.DOCUMENT_ALREADY_READS_AS_PROPOSED_MESSAGE;
  return null;
}
function cardBuildFailuresWithEntry(cardBuildFailureByEntry, entryIndex, cardBuildFailure) {
  var _cardBuildFailureByEn;
  if (((_cardBuildFailureByEn = cardBuildFailureByEntry.get(entryIndex)) !== null && _cardBuildFailureByEn !== void 0 ? _cardBuildFailureByEn : null) === cardBuildFailure) return cardBuildFailureByEntry;
  var nextCardBuildFailureByEntry = new Map(cardBuildFailureByEntry);
  if (cardBuildFailure === null) nextCardBuildFailureByEntry.delete(entryIndex);else nextCardBuildFailureByEntry.set(entryIndex, cardBuildFailure);
  return nextCardBuildFailureByEntry;
}
var NO_CARD_BUILD_FAILURES = new Map();
var NO_CONFLICTING_CARDS = [];
var NO_POTENTIAL_COLLISIONS = [];
var REDLINE_ALREADY_APPLIED_MESSAGE = "This redline is already applied.";
var RepairLabel = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 11px;\n  color: #666;\n  font-style: italic;\n"])));
function driftLabel(detail) {
  /**
   * WHEN drift detail is absent
   *   RETURNS
   *     "content" as the generic label.
   */
  if (!detail) return "content";
  if (detail.textDiff && detail.commentsDiff) return "text and comments";
  if (detail.textDiff) return "text";
  if (detail.commentsDiff) return "comments";
  return "content";
}
var RedlineSection = function RedlineSection(_ref) {
  var _cardBuildFailureByEn2, _proposalEdit$editReq;
  var ooxmls = _ref.ooxmls,
    textRedline = _ref.textRedline,
    cardComments = _ref.cardComments,
    actionId = _ref.actionId,
    target_ooxml_befores = _ref.target_ooxml_befores,
    bookmarks = _ref.bookmarks,
    afterBookmarks = _ref.afterBookmarks,
    _onRegenerate = _ref.onRegenerate,
    isRegenerating = _ref.isRegenerating,
    _ref$showFeedbackForm = _ref.showFeedbackForm,
    showFeedbackForm = _ref$showFeedbackForm === void 0 ? false : _ref$showFeedbackForm,
    onToggleFeedback = _ref.onToggleFeedback,
    isActionApplied = _ref.isActionApplied,
    onActionApplied = _ref.onActionApplied,
    onActionFailed = _ref.onActionFailed,
    isActionDismissed = _ref.isActionDismissed,
    isDismissalSaving = _ref.isDismissalSaving,
    onActionDismissed = _ref.onActionDismissed,
    onActionUndismissed = _ref.onActionUndismissed,
    onGoToIssue = _ref.onGoToIssue,
    recoveryWarning = _ref.recoveryWarning,
    onRecoveryWarning = _ref.onRecoveryWarning,
    onCardCommentRelocated = _ref.onCardCommentRelocated,
    applyFailure = _ref.applyFailure,
    supersededBy = _ref.supersededBy,
    partSupersededBy = _ref.partSupersededBy,
    _ref$revertedInDocume = _ref.revertedInDocument,
    revertedInDocument = _ref$revertedInDocume === void 0 ? false : _ref$revertedInDocume,
    _ref$partlyRevertedIn = _ref.partlyRevertedInDocument,
    partlyRevertedInDocument = _ref$partlyRevertedIn === void 0 ? false : _ref$partlyRevertedIn,
    _ref$conflictingCards = _ref.conflictingCards,
    conflictingCards = _ref$conflictingCards === void 0 ? NO_CONFLICTING_CARDS : _ref$conflictingCards,
    _ref$potentialCollisi = _ref.potentialCollisions,
    potentialCollisions = _ref$potentialCollisi === void 0 ? NO_POTENTIAL_COLLISIONS : _ref$potentialCollisi,
    _ref$proposalCard = _ref.proposalCard,
    proposalCard = _ref$proposalCard === void 0 ? null : _ref$proposalCard,
    _ref$proposalCardCont = _ref.proposalCardContext,
    proposalCardContext = _ref$proposalCardCont === void 0 ? null : _ref$proposalCardCont,
    _ref$proposalCardSumm = _ref.proposalCardSummary,
    proposalCardSummary = _ref$proposalCardSumm === void 0 ? null : _ref$proposalCardSumm,
    _ref$proposalCardComm = _ref.proposalCardComments,
    proposalCardComments = _ref$proposalCardComm === void 0 ? null : _ref$proposalCardComm,
    isPartiallyApplied = _ref.isPartiallyApplied,
    _ref$isWrittenBack = _ref.isWrittenBack,
    isWrittenBack = _ref$isWrittenBack === void 0 ? false : _ref$isWrittenBack,
    onApplyFailed = _ref.onApplyFailed,
    onPrevStep = _ref.onPrevStep,
    onNextStep = _ref.onNextStep,
    currentStepIndex = _ref.currentStepIndex,
    totalSteps = _ref.totalSteps,
    _ref$proposalEdit = _ref.proposalEdit,
    proposalEdit = _ref$proposalEdit === void 0 ? null : _ref$proposalEdit,
    _ref$heldBackReasonOf = _ref.heldBackReasonOfTheCard,
    heldBackReasonOfTheCard = _ref$heldBackReasonOf === void 0 ? null : _ref$heldBackReasonOf;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    editorActionsSlot = _useState4[0],
    setEditorActionsSlot = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    proposalPackageOoxml = _useState6[0],
    setProposalPackageOoxml = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    proposalStampedAt = _useState8[0],
    setProposalStampedAt = _useState8[1];
  var takeProposalPackage = function takeProposalPackage(packageOoxml, stampedAt) {
    setProposalPackageOoxml(packageOoxml);
    setProposalStampedAt(stampedAt);
  };
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    documentAlreadyReadsAsProposed = _useState0[0],
    setDocumentAlreadyReadsAsProposed = _useState0[1];
  var _useState1 = (0, _react.useState)(NO_CARD_BUILD_FAILURES),
    _useState10 = _slicedToArray(_useState1, 2),
    cardBuildFailureByEntry = _useState10[0],
    setCardBuildFailureByEntry = _useState10[1];
  var reportCardBuildFailureOfEntry = function reportCardBuildFailureOfEntry(entryIndex) {
    return function (cardBuildFailure) {
      setCardBuildFailureByEntry(function (failuresByEntry) {
        return cardBuildFailuresWithEntry(failuresByEntry, entryIndex, cardBuildFailure);
      });
    };
  };
  var cardBuildFailure = (_cardBuildFailureByEn2 = cardBuildFailureByEntry.values().next().value) !== null && _cardBuildFailureByEn2 !== void 0 ? _cardBuildFailureByEn2 : null;
  var _useCardsNotShown = (0, _CardsNotShownContext.useCardsNotShown)(_CardsNotShownContext.CARD_BUILD_SOURCE),
    markCardNotShown = _useCardsNotShown.markNotShown;
  (0, _react.useEffect)(function () {
    if (cardBuildFailure === null) return undefined;
    markCardNotShown([actionId], cardBuildFailure);
    return function () {
      return markCardNotShown([actionId], null);
    };
  }, [actionId, cardBuildFailure, markCardNotShown]);
  /**
   * CASES
   *   - the card is applied                               -> Apply is held back: writing it again refuses or doubles its words
   *   - the card itself holds Apply back                   -> Apply is held back with its reason: a change made throughout with no place checked,
   *                                                           whose preview then also reads as the document does
   *   - the live preview's build of the card failed       -> Apply is held back with the engine's error: Apply builds the same card over the same page
   *   - the live preview built nothing to change          -> Apply is held back: the document already reads as the card proposes
   *   - otherwise                                         -> Apply runs
   */
  var applyHeldBackReason = applyHeldBackReasonOf(isActionApplied, documentAlreadyReadsAsProposed, heldBackReasonOfTheCard, cardBuildFailure);
  var editRequested = (_proposalEdit$editReq = proposalEdit === null || proposalEdit === void 0 ? void 0 : proposalEdit.editRequested) !== null && _proposalEdit$editReq !== void 0 ? _proposalEdit$editReq : false;
  var onEditRequestHandled = proposalEdit === null || proposalEdit === void 0 ? void 0 : proposalEdit.onEditRequestHandled;
  var onEditOpened = proposalEdit === null || proposalEdit === void 0 ? void 0 : proposalEdit.onEditOpened;
  var openEditor = function openEditor() {
    setIsEditing(true);
    onEditOpened === null || onEditOpened === void 0 || onEditOpened();
  };
  var closeEditor = function closeEditor() {
    return setIsEditing(false);
  };
  (0, _react.useEffect)(function () {
    if (editRequested) {
      setIsEditing(true);
      onEditOpened === null || onEditOpened === void 0 || onEditOpened();
      onEditRequestHandled === null || onEditRequestHandled === void 0 || onEditRequestHandled();
    }
  }, [editRequested, onEditRequestHandled, onEditOpened]);
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    currentTextMatches = _useState12[0],
    setCurrentTextMatches = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    differenceDetails = _useState14[0],
    setDifferenceDetails = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    isApplying = _useState16[0],
    setIsApplying = _useState16[1];
  var _useState17 = (0, _react.useState)({}),
    _useState18 = _slicedToArray(_useState17, 2),
    isRepairingByIndex = _useState18[0],
    setIsRepairingByIndex = _useState18[1];
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var applyRedline = (0, _useApplyRedline.useApplyRedlineOrFail)();
  var liveProposalRegistry = (0, _useLiveProposal.useLiveProposalRegistry)();
  // const cardDetails = useCardDetails();
  var _useContext = (0, _react.useContext)(_insertionLandingsContext.InsertionLandingsContext),
    isRankingSlotOf = _useContext.isRankingSlotOf;
  var isSlotBeingRanked = actionId !== null && isRankingSlotOf(actionId);
  (0, _react.useEffect)(function () {
    var checkTextMatches = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var targetOoxmlBeforesExist, bookmarksExist, driftCheckInputsAreMissing, onError, currentOoxml, results, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              targetOoxmlBeforesExist = Boolean(target_ooxml_befores === null || target_ooxml_befores === void 0 ? void 0 : target_ooxml_befores.length);
              bookmarksExist = Boolean(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.length);
              driftCheckInputsAreMissing = !targetOoxmlBeforesExist || !bookmarksExist;
              /**
               * WHEN baseline OOXML or bookmarks are missing
               *   CONSEQUENCE
               *     Skip drift checking and clear prior match results.
               */
              if (!driftCheckInputsAreMissing) {
                _context.n = 1;
                break;
              }
              setCurrentTextMatches([]);
              setDifferenceDetails([]);
              return _context.a(2);
            case 1:
              /**
               * WHY
               *   Analytics expects an Error-shaped value.
               * FALLBACK
               *   Wrap thrown non-Error values with new Error(String(error)).
               */
              onError = function onError(error) {
                return sendError(error instanceof Error ? error : new Error(String(error)), {
                  component: "RedlineSection",
                  action: "compare_ooxml"
                });
              };
              _context.p = 2;
              _context.n = 3;
              return (0, _document.getOoxmlForBookmarks)(bookmarks);
            case 3:
              currentOoxml = _context.v;
              if (currentOoxml) {
                _context.n = 4;
                break;
              }
              setCurrentTextMatches([]);
              setDifferenceDetails([]);
              return _context.a(2);
            case 4:
              results = target_ooxml_befores.map(function (target) {
                return (0, _ooxmlTextCompare.compareOoxmlContent)(currentOoxml, target, onError);
              });
              setCurrentTextMatches(results.map(function (r) {
                return r.matches;
              }));
              setDifferenceDetails(results.map(function (r) {
                return {
                  textDiff: r.textDiff,
                  commentsDiff: r.commentsDiff
                };
              }));
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              (0, _toast.toastError)(_t);
              sendError(_t, {
                component: "RedlineSection",
                action: "check_text_matches",
                bookmarks: bookmarks
              });
              setCurrentTextMatches([]);
              setDifferenceDetails([]);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[2, 5]]);
      }));
      return function checkTextMatches() {
        return _ref2.apply(this, arguments);
      };
    }();
    checkTextMatches();
  }, [bookmarks, target_ooxml_befores]);
  var mergeOoxml = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3, index) {
      var ooxml, atBookmarks, afters, targetBookmarks, access, _access$authorName, liveRequest, errorIsUntrackedWriteRefused, errorIsApplyFailureError, errorIsUserFacingRefusal, errorShouldBeRethrown, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            ooxml = _ref3.ooxml, atBookmarks = _ref3.atBookmarks, afters = _ref3.afterBookmarks;
            targetBookmarks = afters !== null && afters !== void 0 ? afters : atBookmarks;
            _context2.n = 1;
            return _proposalEngineAccess.ProposalEngineAccess.current().catch(function () {
              return null;
            });
          case 1:
            access = _context2.v;
            if (access !== null && access.signedIn) {
              liveRequest = (0, _cardLiveProposal.liveProposalRequestOf)((0, _cardLiveProposal.cardLivePreviewOf)({
                markup: ooxml,
                textRedline: textRedline,
                bookmarks: bookmarks !== null && bookmarks !== void 0 ? bookmarks : [],
                afterBookmarks: afterBookmarks !== null && afterBookmarks !== void 0 ? afterBookmarks : [],
                edit: proposalEdit === null ? null : {
                  textRedlineToEdit: proposalEdit.textRedlineToEdit,
                  textRedlineBeforeEdit: proposalEdit.textRedlineBeforeEdit,
                  textRedlineWhenOpened: proposalEdit.textRedlineWhenOpened,
                  editAuthor: proposalEdit.editAuthor
                }
              }), (_access$authorName = access.authorName) !== null && _access$authorName !== void 0 ? _access$authorName : _redlineEngine.DIOPTRA_AUTHOR);
              if (liveRequest !== null) liveProposalRegistry.freezeAppliedLook(liveRequest);
            }
            _context2.p = 2;
            _context2.n = 3;
            return applyRedline({
              ooxml: ooxml,
              textRedline: textRedline,
              cardComments: actionId === null ? cardComments : _cardCommentSelections.cardCommentSelections.checkedCommentsOf(actionId, cardComments),
              actionId: actionId,
              initiatedFrom: "single",
              bookmarks: targetBookmarks,
              insertAfter: Boolean(afters === null || afters === void 0 ? void 0 : afters.length),
              onCommentRelocated: function onCommentRelocated(relocatedCardComment) {
                return onCardCommentRelocated === null || onCardCommentRelocated === void 0 ? void 0 : onCardCommentRelocated(relocatedCardComment);
              },
              onStatus: function onStatus(status) {
                setIsRepairingByIndex(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, index, status === "in_progress"));
                });
                /**
                 * WHEN apply status is "warning"
                 *   CONSEQUENCE
                 *     Persist the recovery warning for later renders.
                 */
                if (status === "warning") onRecoveryWarning === null || onRecoveryWarning === void 0 || onRecoveryWarning(_ooxmlRecovery.RECOVERY_USED_MESSAGE);
              }
            });
          case 3:
            _context2.n = 6;
            break;
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            errorIsUntrackedWriteRefused = _t2 instanceof _untrackedWriteGuard.UntrackedWriteRefused;
            errorIsApplyFailureError = _t2 instanceof _errors.ApplyFailureError;
            errorIsUserFacingRefusal = _t2 instanceof _errors.UserFacingError;
            errorShouldBeRethrown = errorIsUntrackedWriteRefused || errorIsApplyFailureError || errorIsUserFacingRefusal;
            /**
             * CASES
             *   - UntrackedWriteRefused -> rethrow as-is
             *   - ApplyFailureError     -> rethrow as-is
             *   - UserFacingError       -> rethrow as-is
             *
             * WHY the third
             *   A refusal is raised before anything is written — the proposal engine being
             *   off for the account, a remedy whose target cannot be located. Wrapping one
             *   as PartialRedlineApply told the lawyer part of their redline had landed
             *   when none of it had, and the partial-apply handling takes the card's Apply
             *   button away, so the refusal left them with no way to try again.
             */
            if (!errorShouldBeRethrown) {
              _context2.n = 5;
              break;
            }
            throw _t2;
          case 5:
            throw new _errors.PartialRedlineApply(0, 1, _t2 instanceof Error ? _t2 : new Error(String(_t2)));
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 4]]);
    }));
    return function mergeOoxml(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleApply = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(ooxml, index) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            setIsApplying(index);
            _context3.p = 1;
            _context3.n = 2;
            return (0, _applyOutcome.runRecordedApply)(function () {
              var hasAfterBookmarks = function hasAfterBookmarks() {
                var afterBookmarksExist = Boolean(afterBookmarks);
                if (!afterBookmarksExist) return false;
                return afterBookmarks.length > 0;
              };
              /**
               * WHEN afterBookmarks are present and the card carries markup
               *   CONSEQUENCE
               *     Apply by inserting after those anchors. A text card (a regenerated new
               *     paragraph) holds its insertion's place itself and applies on its bookmarks.
               */
              if (hasAfterBookmarks() && !(ooxml.length === 0 && textRedline !== null)) return mergeOoxml({
                ooxml: ooxml,
                afterBookmarks: afterBookmarks
              }, index);
              /**
               * WHEN bookmarks are present and afterBookmarks were not used
               *   CONSEQUENCE
               *     Apply at those anchors for in-place replacement.
               */
              if (bookmarks && bookmarks.length > 0) return mergeOoxml({
                ooxml: ooxml,
                atBookmarks: bookmarks
              }, index);
              return mergeOoxml({
                ooxml: ooxml
              }, index);
            }, {
              markApplied: function markApplied() {
                return onActionApplied === null || onActionApplied === void 0 ? void 0 : onActionApplied();
              },
              markFailed: function markFailed(reason) {
                return onActionFailed === null || onActionFailed === void 0 ? void 0 : onActionFailed(reason);
              },
              onError: function onError(error) {
                if (!(error instanceof _errors.WrittenBackRedlineApply)) (0, _toast.toastError)(error);
                var applyFailureReason = (0, _errors.userMessageOf)(error);
                var errorIsPartiallyApplied = error instanceof _errors.PartialRedlineApply;
                var applyFailure = {
                  reason: applyFailureReason,
                  isPartiallyApplied: errorIsPartiallyApplied,
                  conflictingActionIds: [],
                  writtenBack: error instanceof _errors.WrittenBackRedlineApply
                };
                onApplyFailed === null || onApplyFailed === void 0 || onApplyFailed(applyFailure);
                var errorIsUserFacingError = error instanceof _errors.UserFacingError;
                var errorIsPartialRedlineApply = error instanceof _errors.PartialRedlineApply && !(error instanceof _errors.WrittenBackRedlineApply);
                var errorShouldBeReported = !errorIsUserFacingError || errorIsPartialRedlineApply;
                /**
                 * CASES
                 *   - not a UserFacingError  -> send telemetry
                 *   - PartialRedlineApply    -> send telemetry
                 *   - other UserFacingError  -> skip extra telemetry
                 */
                if (errorShouldBeReported) {
                  sendError(error, {
                    component: "RedlineSection",
                    action: "apply_changes",
                    bookmarks: bookmarks
                  });
                }
              }
            });
          case 2:
            _context3.p = 2;
            setIsApplying(null);
            setIsRepairingByIndex(function (prev) {
              var next = _objectSpread({}, prev);
              delete next[index];
              return next;
            });
            return _context3.f(2);
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[1,, 2, 3]]);
    }));
    return function handleApply(_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  function renderRegenerateButton() {
    if (!onToggleFeedback) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: function onClick(e) {
        e.stopPropagation();
        /**
         * WHEN regeneration is not already running
         *   CONSEQUENCE
         *     Open feedback.
         * EDGE CASE
         *   Already regenerating -> ignore the click
         */
        if (!isRegenerating) {
          onToggleFeedback();
        }
      },
      disabled: isRegenerating,
      style: {
        background: "none",
        border: "none",
        padding: 2,
        cursor: isRegenerating ? "not-allowed" : "pointer",
        opacity: isRegenerating ? 0.5 : 1,
        display: "flex",
        alignItems: "center",
        flexShrink: 0
      },
      "data-sentry-component": "renderRegenerateButton",
      "data-sentry-source-file": "RedlineSection.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyRegenerateIcon, {
        src: _Regenerate.default,
        alt: "Regenerate",
        width: 16,
        height: 16,
        $isRegenerating: isRegenerating,
        "data-sentry-element": "RemedyRegenerateIcon",
        "data-sentry-source-file": "RedlineSection.tsx"
      })
    });
  }
  var appliedIndicator = supersededBy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedySupersededIndicator, {
    supersededBy: supersededBy,
    onShowSuperseder: null
  }) : partSupersededBy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyPartSupersededIndicator.RemedyPartSupersededIndicator, {
    partSupersededBy: partSupersededBy
  }) : partlyRevertedInDocument ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RevertedInDocumentIndicator.PartlyRevertedInDocumentIndicator, {}) : recoveryWarning ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1 text-[11px] text-[#B45309] font-medium",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      width: 14,
      height: 14,
      className: "text-[#B45309]"
    }), "Applied", /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
      content: recoveryWarning,
      align: "start",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "inline-flex items-center cursor-help text-[#F59E0B] ml-0.5",
        "aria-label": "Recovery warning",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 14,
          height: 14
        })
      })
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
  function renderStatus() {
    /**
     * WHEN the action is dismissed
     *   CONSEQUENCE
     *     Show dismissed state before failure or applied state.
     */
    if (isActionDismissed) {
      /**
       * CASES
       *   - onActionUndismissed exists -> render a clickable dismissed indicator
       *   - otherwise                 -> return null
       */
      return onActionUndismissed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissedIndicator, {
        onClick: function onClick(e) {
          e.stopPropagation();
          onActionUndismissed();
        },
        isSaving: Boolean(isDismissalSaving)
      }) : null;
    }
    /**
     * WHEN applyFailure is present
     *   CONSEQUENCE
     *     Render the failed indicator.
     */
    if (applyFailure) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyFailedIndicator, {
      reason: applyFailure,
      conflictingCards: conflictingCards,
      partlyApplied: Boolean(isPartiallyApplied)
    });
    /**
     * WHEN the action is applied
     *   CONSEQUENCE
     *     Render the applied indicator after dismissed and failed cases are ruled out.
     */
    if (isActionApplied) return appliedIndicator;
    if (supersededBy) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedySupersededIndicator, {
      supersededBy: supersededBy,
      onShowSuperseder: null
    });
    if (revertedInDocument) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RevertedInDocumentIndicator.RevertedInDocumentIndicator, {});
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyPotentialCollisionIndicator, {
      collisions: potentialCollisions,
      "data-sentry-element": "RemedyPotentialCollisionIndicator",
      "data-sentry-component": "renderStatus",
      "data-sentry-source-file": "RedlineSection.tsx"
    });
  }
  var renderActions = function renderActions(ooxml, index) {
    var hasBookmarks = bookmarks && bookmarks.length > 0;
    /**
     * WHEN this proposal has no bookmark anchors
     *   CONSEQUENCE
     *     No document apply path here. Offer feedback/regeneration only.
     */
    if (!hasBookmarks) {
      /**
       * CASES
       *   - onToggleFeedback exists -> render the regenerate entry point
       *   - otherwise              -> return null
       */
      return onToggleFeedback ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyRegenerateIcon, {
        src: _Regenerate.default,
        alt: "Regenerate",
        width: 20,
        height: 20,
        $isRegenerating: isRegenerating,
        onClick: function onClick(e) {
          e.stopPropagation();
          /**
           * WHEN regeneration is not already running
           *   CONSEQUENCE
           *     Open feedback.
           * EDGE CASE
           *   Already regenerating -> ignore the click
           */
          if (!isRegenerating) {
            onToggleFeedback();
          }
        },
        style: {
          cursor: isRegenerating ? "not-allowed" : "pointer",
          opacity: isRegenerating ? 0.5 : 1
        }
      }) : null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [isRepairingByIndex[index] && /*#__PURE__*/(0, _jsxRuntime.jsx)(RepairLabel, {
        children: "Auto-repairing redline\u2026"
      }), onActionApplied && !isActionDismissed && !isPartiallyApplied && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        onClick: (/*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  e.stopPropagation();
                  e.preventDefault();
                  _context4.n = 1;
                  return handleApply(ooxml, index);
                case 1:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x5) {
            return _ref6.apply(this, arguments);
          };
        }()),
        isLoading: isApplying === index,
        disabled: applyHeldBackReason !== null,
        title: applyHeldBackReason !== null && applyHeldBackReason !== void 0 ? applyHeldBackReason : undefined
      }), onActionApplied && !isActionDismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyGoToIssueButton, {
        onClick: (/*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  e.stopPropagation();
                  e.preventDefault();
                  /**
                   * WHEN onGoToIssue is provided
                   *   CONSEQUENCE
                   *     Run issue navigation.
                   */
                  if (!onGoToIssue) {
                    _context5.n = 1;
                    break;
                  }
                  _context5.n = 1;
                  return onGoToIssue();
                case 1:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x6) {
            return _ref7.apply(this, arguments);
          };
        }()),
        children: "Go to issue"
      }), !isActionDismissed && renderRegenerateButton(), !isActionApplied && !isActionDismissed && onActionDismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissButton, {
        onClick: function onClick(e) {
          e.stopPropagation();
          onActionDismissed();
        },
        isSaving: Boolean(isDismissalSaving)
      }), renderStatus()]
    });
  };
  function renderProposalCard(identity, ooxml, index, stepNavigation) {
    var collisionsWhilePending = isActionApplied || isActionDismissed || applyFailure ? NO_POTENTIAL_COLLISIONS : potentialCollisions;
    var repairLabel = isRepairingByIndex[index] ? /*#__PURE__*/(0, _jsxRuntime.jsx)(RepairLabel, {
      children: "Auto-repairing redline\u2026"
    }) : null;
    var linksNeedingAddressIndicator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinksNeedingAddressIndicator.LinksNeedingAddressIndicator, {
      linksNeedingAddress: (0, _LinksNeedingAddressIndicator.linksNeedingAddressOf)(textRedline),
      density: "chatCard"
    });
    var controls = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalCardActions.ProposalCardActions, {
      leadingContent: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [stepNavigation, repairLabel]
      }),
      onApply: function onApply() {
        return handleApply(ooxml, index);
      },
      isApplying: isApplying === index,
      applyHeldBackReason: applyHeldBackReason,
      onGoToIssue: onGoToIssue,
      isActionApplied: Boolean(isActionApplied),
      isActionDismissed: Boolean(isActionDismissed),
      isDismissalSaving: Boolean(isDismissalSaving),
      isPartiallyApplied: Boolean(isPartiallyApplied),
      isWrittenBack: isWrittenBack,
      onActionDismissed: onActionDismissed,
      onActionUndismissed: onActionUndismissed,
      applyFailure: applyFailure,
      conflictingCards: conflictingCards,
      edit: proposalEdit !== null ? {
        onEdit: openEditor,
        isEditing: isEditing,
        editorActionsSlotRef: setEditorActionsSlot,
        onResetToAgentVersion: proposalEdit.textRedlineBeforeEdit !== null ? proposalEdit.onResetToAgentVersion : null
      } : null,
      appliedIndicator: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [appliedIndicator, linksNeedingAddressIndicator]
      }),
      pendingIndicator: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [revertedInDocument && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RevertedInDocumentIndicator.RevertedInDocumentIndicator, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyPotentialCollisionIndicator, {
          collisions: collisionsWhilePending
        }), linksNeedingAddressIndicator]
      }),
      isVerifyingOrder: isApplying === index && isSlotBeingRanked
      // onShowDetails={actionId === null ? undefined : () => cardDetails.open(actionId, identity.cardNumber ?? null)}
    });
    var content = renderProposalCardContent(ooxml, index);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalCard.ProposalCard, {
      identity: identity,
      density: "chat",
      tone: isActionDismissed ? "dismissed" : "default",
      controls: controls,
      content: content,
      context: proposalCardContext,
      comments: proposalCardComments,
      collapsedSummary: proposalCardSummary,
      expanded: isEditing,
      "data-sentry-element": "ProposalCard",
      "data-sentry-component": "renderProposalCard",
      "data-sentry-source-file": "RedlineSection.tsx"
    }, index);
  }
  var placesShowEachChange = proposalCardSummary !== null;
  function renderLivePreview(ooxml, entryIndex) {
    var preview = (0, _cardLiveProposal.cardLivePreviewOf)({
      markup: ooxml,
      textRedline: textRedline,
      bookmarks: bookmarks !== null && bookmarks !== void 0 ? bookmarks : [],
      afterBookmarks: afterBookmarks !== null && afterBookmarks !== void 0 ? afterBookmarks : [],
      edit: proposalEdit === null ? null : {
        textRedlineToEdit: proposalEdit.textRedlineToEdit,
        textRedlineBeforeEdit: proposalEdit.textRedlineBeforeEdit,
        textRedlineWhenOpened: proposalEdit.textRedlineWhenOpened,
        editAuthor: proposalEdit.editAuthor
      }
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveProposalPanel.default, {
      bookmarkNames: preview.bookmarkNames,
      redlineOoxml: preview.redlineOoxml,
      textRedline: preview.textRedline,
      editLayer: preview.editLayer,
      onProposalPackage: proposalEdit === null ? null : takeProposalPackage,
      onDocumentAlreadyReadsAsProposed: setDocumentAlreadyReadsAsProposed,
      onCardBuildFailure: reportCardBuildFailureOfEntry(entryIndex),
      insertAfter: preview.insertAfter,
      hidden: placesShowEachChange,
      applied: Boolean(isActionApplied),
      framed: false,
      "data-sentry-element": "LiveProposalPanel",
      "data-sentry-component": "renderLivePreview",
      "data-sentry-source-file": "RedlineSection.tsx"
    });
  }
  function renderPreviewOrHeldBackReason(ooxml, entryIndex) {
    if (heldBackReasonOfTheCard === null || isActionApplied) return renderLivePreview(ooxml, entryIndex);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "status",
      className: "mt-2 text-[11px] italic text-[#666]",
      "data-sentry-component": "renderPreviewOrHeldBackReason",
      "data-sentry-source-file": "RedlineSection.tsx",
      children: heldBackReasonOfTheCard
    });
  }
  function renderProposalCardContent(ooxml, entryIndex) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [isPartiallyApplied && applyFailure && !isWrittenBack ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        role: "status",
        className: "text-[11px] text-[#A81E36]",
        children: applyFailure
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: isEditing ? "hidden" : undefined,
        children: renderPreviewOrHeldBackReason(ooxml, entryIndex)
      }), proposalEdit !== null && isEditing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalEditorOnPage.ProposalEditorOnPage, {
        textRedline: proposalEdit.textRedlineToEdit,
        textRedlineBeforeEdit: proposalEdit.textRedlineBeforeEdit,
        textRedlineWhenOpened: proposalEdit.textRedlineWhenOpened,
        author: proposalEdit.editAuthor,
        proposalPackageOoxml: proposalPackageOoxml,
        proposalStampedAt: proposalStampedAt,
        actionsSlot: editorActionsSlot,
        onSave: function onSave(edited, textRedlineWhenOpened) {
          proposalEdit.onSave(edited, textRedlineWhenOpened);
          closeEditor();
        },
        onCancel: closeEditor
      }) : null]
    });
  }

  /**
   * CASES
   *   - the card carries markup -> one entry per markup string
   *   - the card carries texts  -> one entry with no markup; the live proposal panel is its preview
   *   - neither                 -> nothing to preview
   */
  var cards = ooxmls.length > 0 ? ooxmls : textRedline !== null ? [""] : [];

  /**
   * WHEN there are no previewable redlines
   *   CONSEQUENCE
   *     Render status only.
   */
  if (cards.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center gap-2",
      children: renderStatus()
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-sentry-component": "RedlineSection",
    "data-sentry-source-file": "RedlineSection.tsx",
    children: [cards.map(function (ooxml, index) {
      var drift = currentTextMatches[index] === false && (target_ooxml_befores === null || target_ooxml_befores === void 0 ? void 0 : target_ooxml_befores.length) && !isActionApplied;
      var stepNav = totalSteps && totalSteps > 1 && bookmarks && bookmarks.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyStepNavigation, {
        currentStepIndex: currentStepIndex !== null && currentStepIndex !== void 0 ? currentStepIndex : 0,
        totalSteps: totalSteps,
        onPrev: function onPrev() {
          return onPrevStep === null || onPrevStep === void 0 ? void 0 : onPrevStep();
        },
        onNext: function onNext() {
          return onNextStep === null || onNextStep === void 0 ? void 0 : onNextStep();
        }
      }) : undefined;
      if (proposalCard !== null) return renderProposalCard(proposalCard, ooxml, index, stepNav);
      /**
       * WHEN the card carries no markup (a text card)
       *   CONSEQUENCE
       *     The preview is the live proposal panel's built package; only the actions render here.
       */
      if (ooxml.length === 0) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [stepNav, renderActions(ooxml, index)]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveProposalPanel.default, {
            bookmarkNames: bookmarks !== null && bookmarks !== void 0 ? bookmarks : [],
            redlineOoxml: null,
            textRedline: textRedline,
            editLayer: null,
            onProposalPackage: null,
            onDocumentAlreadyReadsAsProposed: setDocumentAlreadyReadsAsProposed,
            onCardBuildFailure: reportCardBuildFailureOfEntry(index),
            insertAfter: false,
            hidden: Boolean(isActionDismissed),
            applied: Boolean(isActionApplied),
            framed: true
          })]
        }, index);
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlinePreview.default, {
          ooxml: ooxml,
          driftWarning: drift ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RemedyActionPrimitives.RemedyDriftWarning, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _triangleAlert.default,
              alt: "Warning",
              width: "16",
              height: "16",
              style: {
                flexShrink: 0
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: ["We detected differences in the current document ", driftLabel(differenceDetails[index]), " compared to what was used to compute these redlines. Please regenerate to take into account the current document content."]
            })]
          }) : undefined,
          stepNavigation: stepNav,
          actions: renderActions(ooxml, index)
          /**
           * EXAMPLE
           *   cards.length = 3         -> last index is 2
           *   index = 0 or 1           -> marginBottom = 8
           *   index = 2                -> marginBottom = 0
           */,
          containerStyle: {
            marginBottom: index < cards.length - 1 ? 8 : 0
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveProposalPanel.default, {
          bookmarkNames: bookmarks !== null && bookmarks !== void 0 ? bookmarks : [],
          redlineOoxml: ooxml,
          textRedline: null,
          editLayer: null,
          onProposalPackage: null,
          onDocumentAlreadyReadsAsProposed: setDocumentAlreadyReadsAsProposed,
          onCardBuildFailure: reportCardBuildFailureOfEntry(index),
          insertAfter: Boolean(afterBookmarks === null || afterBookmarks === void 0 ? void 0 : afterBookmarks.length),
          hidden: Boolean(isActionDismissed) || Boolean(isActionApplied),
          applied: Boolean(isActionApplied),
          framed: true
        })]
      }, index);
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AIFeedbackModal.default, {
      isOpen: showFeedbackForm,
      onClose: function onClose() {
        return onToggleFeedback === null || onToggleFeedback === void 0 ? void 0 : onToggleFeedback();
      },
      onRegenerate: function onRegenerate(feedback) {
        return (_onRegenerate === null || _onRegenerate === void 0 ? void 0 : _onRegenerate(feedback)) || Promise.resolve();
      },
      isSubmitting: isRegenerating,
      "data-sentry-element": "AIFeedbackModal",
      "data-sentry-source-file": "RedlineSection.tsx"
    })]
  });
};
var _default = exports.default = /*#__PURE__*/_react.default.memo(RedlineSection, areRedlineSectionPropsEqual);